import React, { useState, useRef, useEffect } from "react";

// Hook para detectar media queries
function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    setMatches(media.matches);
    const listener = () => setMatches(media.matches);
    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, [query]);

  return matches;
}

export default function ContenedorCarrusel({
  vClassNameFlechaIzq = "botones-carrusel-izquierda",
  vClassNameFlechaDer = "botones-carrusel-derecha",
  children,
}) {
  const [vIsHover, setVIsHover] = useState(false);
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const carruselRef = useRef(null);

  // Hook para detectar si la pantalla es de tablet (max-width: 768px)
  const isTablet = useMediaQuery("(max-width: 768px)");

  function moverCarrusel(direccion) {
    const fila = carruselRef.current;
    const tarjeta = fila ? fila.firstElementChild : null;
    if (!fila || !tarjeta) return;

    // 1. Ancho del contenedor
    const filaWidth = fila.clientWidth;

    // 2. Ancho de tarjeta
    const tarjetaWidth = tarjeta.offsetWidth;

    // 3. Obtener el gap real entre tarjetas (con CSS computed)
    const estilosFila = window.getComputedStyle(fila);
    const gap = parseInt(estilosFila.columnGap || estilosFila.gap || "0", 10);

    // 4. Cuántas tarjetas caben completas
    const tarjetasVisibles = Math.floor(filaWidth / (tarjetaWidth + gap));

    // 5. Cuánto desplazarnos (múltiplo del ancho total de tarjeta)
    const desplazamiento = tarjetasVisibles * (tarjetaWidth + gap);

    // 6. Hacemos el scroll
    fila.scrollLeft += direccion * desplazamiento;

    // 7. Actualizamos estados de visibilidad
    setIsAtStart(fila.scrollLeft <= 0);
    setIsAtEnd(fila.scrollLeft + fila.clientWidth >= fila.scrollWidth);
  }

  /** Variables nuevas para el nuevo carrusel por bloques */

  /** Fin variables */

  useEffect(() => {
    const fila = carruselRef.current;
    if (fila) {
      setIsAtStart(fila.scrollLeft <= 0);
      setIsAtEnd(fila.scrollLeft + fila.clientWidth >= fila.scrollWidth);
    }
  }, [vIsHover]);

  return (
    <div
      className="contenedor-flechas"
      onMouseEnter={() => setVIsHover(true)}
      onMouseLeave={() => setVIsHover(false)}
    >
      <div
        className={vClassNameFlechaIzq}
        onClick={() => moverCarrusel(-1)}
        style={{
          display: isTablet ? "none" : vIsHover && !isAtStart ? "flex" : "none",
        }}
      >
        <img
          src="https://cdn.prod.website-files.com/67c71c8e8be08ac19b5c455a/67d3b2b761dfb2381b08d10a_flechas-carrusel.svg"
          loading="lazy"
          width="40"
          height="40"
          alt="Flecha izquierda"
          className="flechas-carrusel"
        />
      </div>
      <div
        data-figma-id="113:8902"
        className="home-cursos-explora-contenido"
        ref={carruselRef}
      >
        {children}
      </div>
      <div
        className={vClassNameFlechaDer}
        onClick={() => moverCarrusel(1)}
        style={{
          display: isTablet ? "none" : vIsHover && !isAtEnd ? "flex" : "none",
        }}
      >
        <img
          src="https://cdn.prod.website-files.com/67c71c8e8be08ac19b5c455a/67d3b34a296d9bc376e42068_flechas-carrusel.svg"
          loading="lazy"
          width="40"
          height="40"
          alt="Flecha derecha"
          className="flechas-carrusel"
        />
      </div>
    </div>
  );
}
